import React from "react";
import { StandardResourceItem } from "..";
import { ActivityResource } from "../../types";
import {
  ResourceListContainer,
  ItemContainer,
  Container,
  ResourceListTitleContainer,
  SideBarStyle,
} from "./ActivityResourceList.style";
import { BaseActivityProps } from "../Activity/Activity.component";
import Title from "../Title/Title.component";
import {} from "../StandardResourceItem/StandardResourceItem.style";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import { core } from "../../state";

interface Props extends BaseActivityProps {
  activity: ActivityResource;
}
const ActivityResourceListComponent: React.FC<Props> = (props) => {
  if (props.activity.tracking?.completeCondition === "open") {
    core.setInteractionResult(props.activity.id, "correct");
  }
  return (
    <React.Fragment>
      <Container id={`${props.activity.id}-resources`} className="resources-container">
        {props.activity.title && (
          <ResourceListTitleContainer className="resources-title-container">
            <Title customClass="resources-title" level={2}>
              {props.activity.title}
            </Title>
          </ResourceListTitleContainer>
        )}
        <SideBarStyle className="sidebar-wrapper">
          <SimpleBar style={{ height: "100%", width: "100%" }}>
            <ResourceListContainer className="resourceList-container">
              {props.activity.resourceList.map((item) => (
                <ItemContainer key={item.id}>
                  <StandardResourceItem resource={item} />
                </ItemContainer>
              ))}
            </ResourceListContainer>
          </SimpleBar>
        </SideBarStyle>
      </Container>
    </React.Fragment>
  );
};

export default ActivityResourceListComponent;
